import { useState, useEffect } from "react";
import { useAuth } from "../context/AuthContext";
import { useNavigate, useLocation } from "react-router-dom";
import { authService } from "../services/authService";
import "./Login.css";
import AppDownloadCard from "../app-platform/AppDownloadCard";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [successMessage, setSuccessMessage] = useState(null);

  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (location.state?.message) {
      setSuccessMessage(location.state.message);

      if (location.state?.email) {
        setEmail(location.state.email);
      }

      window.history.replaceState({}, document.title);
    }
  }, [location]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (isLoading) return;

    setIsLoading(true);
    setError(null);

    try {
      const loginData = email.includes("@")
        ? { email, password }
        : { username: email, password };


const response = await authService.login(loginData);

const authData = response?.data;

if (!authData?.token || !authData?.user) {
  throw new Error("Login failed");
}

// Pass ONLY the user object + token
await login(authData.user, authData.token);

const role = authData.user.role?.toLowerCase();

const redirectMap = {
  superadmin: "/dashboard/superadmin",
  admin: "/dashboard",
  agent: "/dashboard",
  sales: "/dashboard",
  accounts: "/dashboard",
  operations: "/dashboard",
};


navigate(redirectMap[role] || "/dashboard");

    } catch (err) {
      console.error("❌ FULL LOGIN ERROR:", err);

      alert(
        err?.response?.data?.message ||
        err?.message ||
        JSON.stringify(err)
      );

      setError(
        err?.response?.data?.message ||
        err?.message ||
        "Login failed"
      );
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-container">
        <div className="login-header">
          <h1>Welcome Back</h1>
          <p>Sign in to your account</p>
        </div>

        <div className="login-form-container">
          {successMessage && (
            <div className="success-message">{successMessage}</div>
          )}

          {error && <div className="error-message">{error}</div>}

          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label>Email or Username</label>
              <input
                type="text"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                disabled={isLoading}
                className="form-input"
              />
            </div>

            <div className="form-group">
              <label>Password</label>
              <input
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                disabled={isLoading}
                className="form-input"
              />
            </div>

            <button type="submit" disabled={isLoading} className="login-button">
              {isLoading ? "Signing in..." : "Sign In"}
            </button>
          </form>

          <AppDownloadCard variant="light" />
        </div>
      </div>
    </div>
  );
}
